import React from 'react';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import NoDataMessageContainer from 'components/content/shared/other/NoDataMessageContainer';
import { IDocument } from 'types/backend_models/documents/IDocument';
import LayoutRow from 'components/content/shared/styling/LayoutRow';
// import DocumentButton from 'components/content/shared/buttons/DocumentButton';
import { downloadDocument } from 'functions/DocumentDownload';
import { DocumentLineButton } from 'components/content/shared/buttons/DocumentLineButton';

interface IProps
{
	documents: IDocument[]
}

function OrderDetailRelatedDocumentsContainer(props: IProps)
{

	function onDocumentClick(doc: IDocument)
	{
		downloadDocument(doc);
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
			<ContainerSectionTitle>Related Documents</ContainerSectionTitle>
			<div className="mh-200" style={{ flex: 'auto', position: 'relative' }}>
				{
					props.documents.length !== 0 &&
					<LayoutRow className={' mgt-10'}>
						{props.documents.map((doc: IDocument, index: number) =>
						{
							let className = "col-12";
							if (index % 2 !== 0) className += " bg-grey";

							return (
								<div key={index} className={className}>
									<DocumentLineButton
										document={doc}
										onClick={onDocumentClick}
										// tooltip="Click to download"
									/>
								</div>
							)
						})}
					</LayoutRow>
				}
				{
					props.documents.length === 0 &&
					<NoDataMessageContainer containerClassName="pos-abs-cover" message="No related documents" />
				}
			</div>
		</div>
	);
};

export default OrderDetailRelatedDocumentsContainer;